export const SHAREABLE_ELEMENTS_BASE_PATH = 'sharedElements';
export const SHAREABLE_ELEMENTS_EXPOSITION_PATH = 'exposition';

export const USER_PROFILE_PATH = 'profile';

/** ADMIN ROUTES */
export const ADMIN_PATH = 'admin';
